import { render } from "./ImageWide.vue?vue&type=template&id=580112b8&scoped=true"
import script from "./ImageWide.vue?vue&type=script&lang=js"
export * from "./ImageWide.vue?vue&type=script&lang=js"

import "./ImageWide.vue?vue&type=style&index=0&id=580112b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580112b8"]])

export default __exports__